import React from "react";
import { Box, Flex, Stack, Text, Button, SquarePen } from "@commonsku/design-system";
import type { Conversation } from "../../types/skubot";

export type ChatSidebarProps = {
  conversations: Conversation[]
  activeId: string | null
  onNewChat: () => void
  onSelectConversation: (id: string) => void
};

export function ChatSidebar(props: ChatSidebarProps) {
  const { conversations, activeId, onNewChat, onSelectConversation } = props;

  return (
    <Flex
      as="aside"
      direction="column"
      w="250px"
      flexShrink={0}
      bg="white"
      borderRight="1px solid"
      borderColor="border.muted"
      minH={0}
    >
      <Flex h="56px" px="16px" align="center" justify="space-between" flexShrink={0}
        borderBottom="1px solid" borderColor="border.muted"
        fontFamily="heading" fontWeight="700" fontSize="16px" color="black">
        skubot chats
      </Flex>

      <Box px="8px" pt="16px" pb="8px" flexShrink={0}>
        <Flex as={Button} w="100%" h="36px" align="center" gap="8px" px="12px" rounded="md" justifyContent="start"
          fontFamily="heading"  fontSize="14px" color={activeId === null ? "brand.fg" : "gray.800"}
          bg={activeId === null ? "brand.muted" : "transparent"}
          _hover={{ bg: activeId === null ? "brand.muted" : "gray.100" }}
          transition="background 120ms ease" onClick={onNewChat}>
          <SquarePen size="md" /> New chat
        </Flex>
      </Box>

      <Stack flex="1" minH={0} gap="2px" px="8px" py="16px" overflowY="auto">
        {conversations.map((conversation) => {
          const selected = conversation.sessionId === activeId;

          return (
            <Button
              key={conversation.sessionId}
              type="button"
              variant="ghost"
              size="sm"
              justifyContent="flex-start"
              px="3"
              borderRadius="md"
              color={selected ? "brand.fg" : "gray.800"}
              bg={selected ? "brand.muted" : "transparent"}
              _hover={{ bg: selected ? "brand.muted" : "gray.100" }}
              onClick={() => onSelectConversation(conversation.sessionId)}
            >
              <Text
                fontSize="sm"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                margin="0"
                padding="0"
              >
                {conversation.title}
              </Text>
            </Button>
          );
        })}
      </Stack>
    </Flex>
  );
}
